
import React from "react";
import {
    Button,
    FlexColumn,
    SeparatorLine,
    SushiModal,
    WhiteWrapper,
    Wrapper,
} from "../../Common/styles.common";
import { Loader } from "../../Common/Loader";
import DDPoHeader from "../../Header/DDPoHeader";
import styles from "../../Login/Login.module.scss";
import OtpInput from "react-otp-input";
import { errorDisp } from "../../Login/styles.login";
import Cross from "sushiweb/Icons/all/Cross";
import redCross from "../PodValidationImages/Cross.svg";
import greenCheck from "../PodValidationImages/Check.svg";

export default function DDPodFormV2Mobile({
    po,
    items,
    showLoader,
    tonnage,
    errorMsg,
    otpPage,
    otp,
    setOtp,
    showError,
    openConfirmation,
    imageArray,
    previewImage,
    fileTypeErr,
    errorText,
    showPopUp,
    podPopUp,
    doneMsg,
    navigateToOtpPage,
    makeValidateOtp,
    closeConfirmation,
    imageValidationPopUpCloseHandler,
    handleImageInputChange,
}) {
    return (
        <React.Fragment>
            {showLoader ? (
                <Loader />
            ) : (
                <Wrapper>
                    <DDPoHeader
                        poId={po.id}
                        purchaseOrderNumber={po.purchase_order_number}
                        itemsLength={items.length}
                        tonnage={tonnage}
                        source="podForm"
                    />
                    {otpPage ? (
                        <div>
                            <div className="d-flex flex-column po-content">
                                <WhiteWrapper className="invoice-form ml-2 mr-2 mt-1">
                                    <div className="d-flex flex-column mr-4 ml-1">
                                        <span className="fs-18 fw-700">Enter verification code</span>
                                        <span className="fs-12 fw-400 text-gray-cool mt-1 mb-4">
                                            shared by customer during delivery
                                        </span>
                                    </div>
                                    <OtpInput
                                        inputType="number"
                                        containerStyle={`${styles.otpInputField} mb-3`}
                                        value={otp}
                                        onChange={(val) => setOtp(val)}
                                        numInputs={6}
                                        renderSeperator={"-"}
                                        renderInput={(a) => <input {...a} />}
                                    />
                                    {showError ? (
                                        <errorDisp className="fs-12 text-red-700">
                                            {errorText || "Wrong OTP Entered"}
                                        </errorDisp>
                                    ) : (
                                        <></>
                                    )}
                                </WhiteWrapper>
                            </div>
                            <WhiteWrapper className="po-bottom">
                                <Button
                                    className="fs-13 text-white fw-600"
                                    onClick={makeValidateOtp}
                                >
                                    Mark delivered
                                </Button>
                            </WhiteWrapper>
                            <SushiModal visible={openConfirmation} isCentered>
                                <FlexColumn className="align-items-center p-5">
                                    <img src="/logos/tick_logo.svg" height="80px" width="80px" />
                                    <span className="fs-22 fw-700 my-4">Order delivered</span>
                                    <span
                                        className="fs-14 fw-500 text-red-500"
                                        onClick={closeConfirmation}
                                    >
                                        {" "}
                                        Okay
                                    </span>
                                </FlexColumn>
                            </SushiModal>
                        </div>
                    ) : (
                        <div>
                            <div className="d-flex flex-column po-content">
                                <WhiteWrapper className="invoice-form ml-2 mr-2 mt-1">
                                    <div className="d-flex flex-column mr-4 ml-1">
                                        <span className="fs-18 fw-700">Upload hyperpure delivery challan</span>
                                        <span className="fs-12 fw-400 text-gray-cool mt-1">
                                            with signature and issue
                                        </span>
                                        <span className="fs-9 fw-400 text-gray-cool mt-1">
                                            (supported file types are .jpeg, .jpg, .png and .tiff)
                                        </span>
                                    </div>
                                    <SeparatorLine />
                                    <div className="d-flex flex-wrap">
                                        {imageArray.map((box, index) => (
                                            <div key={index}>
                                                <div className="box ml-2 mt-1">
                                                    {previewImage && previewImage[index] ? (
                                                        <div>
                                                            <img
                                                                className="image-preview-1"
                                                                src={previewImage[index]?.img_url}
                                                                alt={`Image-${index + 1}`}
                                                                id={`Image-icon-${index}`}
                                                            />
                                                            <div className="fs-10 fw-400 text-red-500">{`Page ${previewImage[index]?.page_no}`}</div>
                                                        </div>
                                                    ) : (
                                                        <div className="d-flex flex-column">
                                                            <input
                                                                src={"/logos/camera_add.svg"}
                                                                type="file"
                                                                accept="image/*"
                                                                onChange={(e) => handleImageInputChange(e, index + 1)}
                                                                style={{ display: "none" }}
                                                                id={`imageInput-${index}`}
                                                            />
                                                            <label htmlFor={`imageInput-${index}`}>
                                                                <img
                                                                    className="icon"
                                                                    src={"/logos/camera_add.svg"}
                                                                    width="25px"
                                                                    height="25px"
                                                                    alt="Upload Image"
                                                                    id={`Image-icon-${index}`}
                                                                />
                                                            </label>
                                                            <span className="fs-10 fw-400 text-red-500">{`Page ${index + 1}`}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {errorMsg ? (
                                        <errorDisp className="fs-12 text-red-700">
                                            Please add delivery challan
                                        </errorDisp>
                                    ) : doneMsg ? (
                                        <errorDisp className="d-flex mt-2">
                                            <img src={greenCheck} className="mr-1" />
                                            <span className="mt-1 fs-12 text-green-700">All pages uploaded</span>
                                        </errorDisp>
                                    ) : fileTypeErr ? (
                                        <errorDisp className="fs-12 text-red-700">
                                            Please upload images with correct file type
                                        </errorDisp>
                                    ) : (
                                        <></>
                                    )}
                                </WhiteWrapper>
                            </div>
                            <WhiteWrapper className="po-bottom">
                                <Button
                                    className="fs-13 text-white fw-600"
                                    onClick={navigateToOtpPage}
                                >
                                    Verify with OTP
                                </Button>
                            </WhiteWrapper>
                            <SushiModal visible={showPopUp} isCentered>
                                <FlexColumn className="align-items-center p-5">
                                    <div className="align-self-end" onClick={imageValidationPopUpCloseHandler}>
                                        <Cross />
                                    </div>
                                    <img src={podPopUp?.image_link} height="80px" width="80px" />
                                    <span className="fs-22 fw-700 my-4">{podPopUp?.title}</span>
                                    <span className="fs-12 mb-4">{podPopUp?.content}</span>
                                    <div className="invalid-image-box">
                                        <div className="d-flex justify-content-between">
                                            {podPopUp?.negative_tags?.map((tag) => (
                                                <span key={tag} className="d-flex justify-content-between fs-15">
                                                    <img src={redCross} alt="invalid" />
                                                    <span className="mt-1">{tag}</span>
                                                </span>
                                            ))}
                                            {podPopUp?.positive_tags?.map((tag) => (
                                                <span key={tag} className="d-flex justify-content-between fs-15">
                                                    <img src={greenCheck} alt="valid" />
                                                    <span className="mt-1">{tag}</span>
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                    <span
                                        className="fs-14 fw-500 text-red-500 mt-4"
                                        onClick={imageValidationPopUpCloseHandler}
                                    >
                                        Retake photo
                                    </span>
                                </FlexColumn>
                            </SushiModal>
                        </div>
                    )}
                </Wrapper>
            )}
        </React.Fragment>
    );
}
